import Image from "next/image";
import Link from "@/components/UI/Link/Link";
import Button from "@/components/UI/Button/Button";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";

interface Section14Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const TrustSection = ({ job, page, section, ...props }: Section14Props) => {
  return (
    <Section section={section} {...props}>
      <SectionContainer section={section}>
        <SectionHeader section={section} />
        {section?.Images?.data && (
          <div className="flex flex-col items-center justify-center gap-10 lg:flex-row">
            {section?.Images?.data?.map((image: any) => {
              return (
                <Image
                  alt={image?.attributes?.alternativeText}
                  key={image?.id}
                  src={image?.attributes?.url}
                  width={image?.attributes?.width ?? "100"}
                  height={image?.attributes?.height ?? "100"}
                  priority
                />
              );
            })}
          </div>
        )}
        {section?.Blocks?.length > 0 && (
          <div className="flex flex-col gap-8 md:flex-row">
            {section?.Blocks?.map((block: any) => {
              return (
                <div className="flex flex-1 items-center justify-center" key={block?.id}>
                  <div className="flex flex-col gap-10 lg:w-2/3">
                    <div className="text-3xl font-bold">{block?.Title}</div>
                    <div className="text-vpGray-700">{block?.Body}</div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        {section?.Button && (
          <Link className="block" href={section?.Button?.Url ?? ""} variant="external">
            <Button className="mx-auto" size="large">
              {section?.Button?.Value}
            </Button>
          </Link>
        )}
      </SectionContainer>
    </Section>
  );
};

export default TrustSection;
